module.exports = __webpack_public_path__ + "static/media/29ADMSPC2.b0423427.jpg";